"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["ACKNOWLEDGEMENT"] = "acknowledgement";
    NotificationType["CONFIRMATION"] = "confirmation";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
//# sourceMappingURL=notification-type.enum.js.map